import React from "react";
import styles from "./ProductDetail.module.css";
import Carousel from "react-bootstrap/Carousel";
import { Col, Container, Row } from "react-bootstrap";
import LoadPortFolio from "../Portfolio/LoadPortFolio/LoadPortFolio";
import { BASE_URL } from "../../constant/URL";
import { useEffect } from "react";
import { connect } from "react-redux";
import { getProductList } from "../../actions/Book.action";

const ProductDetail = ({ product, data, getProductList }) => {
  useEffect(() => {
    if (!data) {
      getProductList();
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <Carousel variant="dark" className={styles.carouselContainer}>
        {product.images.map((item, i) => (
          <Carousel.Item className={styles.productImageContainer} key={i}>
            <img
              className={`${styles.productImage}`}
              src={`${BASE_URL}/image/${item}`}
              crossOrigin="true"
              alt={`${product.name} ${i}`}
            />
          </Carousel.Item>
        ))}
      </Carousel>

      <div className={`py-5 ${styles.descriptionContainer}`}>
        <h3 className={styles.descriptionTitle}>Status</h3>
        <div className={`top_line mt-3 ${styles.darkTopLine}`}></div>
        <h4 className={styles.status}>
          {product.stock > 0 ? (
            <span className="text-success">In Stock</span>
          ) : (
            <span className="text-success">Out Of Stock</span>
          )}
        </h4>
        <h3 className={styles.descriptionTitle}>Description</h3>
        <div className={`top_line mt-3 ${styles.darkTopLine}`}></div>
        <p className={styles.productDescription}>{product.description}</p>
      </div>

      <div>
        <div className={styles.headline}>
          <h1 className="my-3 mx-3">Similar Products</h1>
        </div>
        <Container>
          <Row>
            {data &&
              data
                .filter((d) => d._id !== product._id)
                .slice(0, 4)
                .map((item) => (
                  <Col md={6} lg={3} key={item._id} className="mb-4">
                    <LoadPortFolio data={item} />
                  </Col>
                ))}
          </Row>
        </Container>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.product.product,
});
export default connect(mapStateToProps, { getProductList })(ProductDetail);
